// Components
const ModalAddEditBrand = () => import(/* webpackPrefetch: true, webpackChunkName: "modal-add-edit-brands"*/ '@/app/views/main-view/brands/modals/modal-add-edit-brands/modal-add-edit-brands.vue');

// Mixins
import { tableMixins } from '@/app/mixins/utils/table-mixins.js';
import { productMixins } from '@/app/mixins/modules/product-mixins.js';
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins.js';

// Services
import BrandService from '@/app/services/main/brands/brand-service';

// Constants
import { STATUS_CODES } from '@/app/constants/constants';

export default {
	name: 'BrandsContainer',
	components: {
		ModalAddEditBrand
	},
	mixins: [
		tableMixins,
		productMixins,
		toastMessageMixins
	],
	data() {
		return {
			isAPILoading: true,
			// table
			theads: [
				{ name: 'Product Type', searchLabel: 'f_productType', sortLabel: 'productType', isDesc: false, hasSearch: true, style: null},
				{ name: 'Brand Name', searchLabel: 'f_name', sortLabel: 'name', isDesc: false, hasSearch: true, style: null},
				{ name: 'Status', searchLabel: 'f_status', sortLabel: 'status', isDesc: false, hasStatusSearch: true, style: 'min-width: 120px'},
				{ name: null, searchLabel: null, sortLabel: null, isDesc: false, hasSearch: false,  style: null}
			],
			// sorting
			desc: true,
			modalContent: {},
		}
	},
	created() {
		this.getTableContent();
	},
	methods: {
		getBrandList(queryParams) {
			// search filters
			if (this.columnsFilter) {
				if (this.columnsFilter.f_name) {
					queryParams['f_name'] = this.columnsFilter.f_name;
				}
				if (this.columnsFilter.f_productType) {
					queryParams['f_productType'] = this.columnsFilter.f_productType;
				}

				if (this.columnsFilter.f_status) {
					queryParams['f_status'] = this.columnsFilter.f_status;
				}
			}

			queryParams['isForTable'] = true;

			this.isAPILoading = true;

			BrandService.getBrands(queryParams)
				.then(res => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination
						};

					} else {
						this.showAPIErrorToast('Unable to fetch brands list.', res);
					}

					this.isAPILoading = false;
				})
				.catch(() => {
						this.showGenericErrorToast();
						this.isAPILoading = false;
				});
		},
		getTableContent(fromFilter, page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc) {
            page = fromFilter ? 1 : this.page;
			this.getBrandList({ page, limit, sortBy, desc });
		},
		reactivateBrand(event, brand) {
			const {name, id} = brand;
			const body = {status : "ACTIVE"};
			// show modal for checked
			if (event.target.checked) {
				this.$swal({
					title: 'Reactivate Brand',
					text: `Are you sure you want to reactivate ${name}?`,
					confirmButtonText: 'Confirm',
					showCancelButton: true,
					cancelButtonText: 'Cancel',
					reverseButtons: true,
					showCloseButton: true,
				})
					.then(result => {
						if (result.value) {
							// API call for reactivate
							BrandService.updateStatusBrand(id,body)
								.then(res => {
									const { SUCCESS_ACTIVATE_TITLE, SUCCESS_ACTIVATE_TEXT, ERROR_ACTIVATE_BRAND } = this.toastMessages.brands(name);

									if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
										this.showCustomSuccessToast(SUCCESS_ACTIVATE_TITLE,SUCCESS_ACTIVATE_TEXT);
										this.isAPILoading = false;
										// refresh table with filter
										this.getTableContent();
									} else {
										this.showAPIErrorToast(ERROR_ACTIVATE_BRAND, res);
										event.target.checked = false;
										this.isAPILoading = false;
									}
								});
						} else {
							event.target.checked = false;
						}
					});
			}
		},
		deactivateBrand(event, brand) {
			const { name, id } = brand;
			const body = {status : "INACTIVE"};
			// show modal confirmation
			if (!event.target.checked) {
				this.$swal({
					title: 'Deactivate Brand',
					text: `Are you sure you want to deactivate ${name}?`,
					confirmButtonText: 'Confirm',
					showCancelButton: true,
					cancelButtonText: 'Cancel',
					reverseButtons: true,
					showCloseButton: true
				})
					.then(result => {
						if (result.value) {
							// API call for update
							BrandService.updateStatusBrand(id,body)
								.then(res => {
									const { SUCCESS_DEACTIVATE_TITLE, SUCCESS_DEACTIVATE_TEXT, ERROR_DEACTIVATE_BRAND_TEXT} = this.toastMessages.brands(name);

									if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
										this.showCustomSuccessToast(SUCCESS_DEACTIVATE_TITLE,SUCCESS_DEACTIVATE_TEXT);
										this.isAPILoading = false;
										// refresh table with filter
										this.getTableContent();
									} else {
										this.showAPIErrorToast(ERROR_DEACTIVATE_BRAND_TEXT, res);
										event.target.checked = true;
										this.isAPILoading = false;
									}
								});
						} else {
							event.target.checked = true;
						}
					});
			}
		},
		deleteBrand(brand) {
			const { name, id } = brand;
			// show modal confirmation
			this.$swal({
				title: `Are you sure you want to delete ${name}?`,
				text: `You won't be able to revert this action.`,
				confirmButtonText: 'Delete',
				showCancelButton: true,
				cancelButtonText: 'Cancel',
				confirmButtonColor: '#dd3333 !important',
				reverseButtons: true,
				showCloseButton: true
			})
			.then(result => {
				if (result.value) {
					// API call for delete
					BrandService.deleteBrand(id).then(res => {
						if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
							this.showCustomSuccessToast('Deleted!', `${name} has been deleted!`);
							// refresh table with filter
							this.getTableContent();
						} else {
							this.showAPIErrorToast(`Unable to delete ${name}`, res);
						}
					});
				}
			});
		},
		showModalAddEditBrand(action, brand) {
			this.modalContent = {};

			if (brand) {
				this.modalContent.brand = brand;
			} 

			this.modalContent.title = action;

			setTimeout(() => {
				this.$refs.modalAddEditBrands.show();
			}, 500);
		}
	}
}